module.exports = __webpack_public_path__ + "antwebbuilding_new481x220.gif?f74fd40503b686f8cc484a8b3252bda6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/antwebbuilding_new481x220.gif
// module id = 24
// module chunks = 0